import { useState } from "react";
import CustomModal from "../components/CustomModal";
import ContentOverlay from "../components/content_overlay";
import "./posters.css";

const posters = [
 
  {
    title: "Wetlands for Human Wellbeing",
    src: [
      "data/posters/wetlands_for_human_wellbeing/1.jpg",
      "data/posters/wetlands_for_human_wellbeing/2.jpg",

      "data/posters/wetlands_for_human_wellbeing/3.jpg",

      "data/posters/wetlands_for_human_wellbeing/4.jpg",
    ],
  },
  {
    title: "EWRG",
    src: [
      "data/posters/EWRG/5.jpg",
      "data/posters/EWRG/6.jpg",

      "data/posters/EWRG/7.jpg",  
    ],
  },
  {
    title: "EWRG-Wetlands",
    src: [
      "data/posters/EWRG-Wetlands/8.jpg",
      "data/posters/EWRG-Wetlands/9.jpg",

      "data/posters/EWRG-Wetlands/10.jpg",

      "data/posters/EWRG-Wetlands/11.jpg",
      "data/posters/EWRG-Wetlands/12.jpg",
      "data/posters/EWRG-Wetlands/13.jpg", 
    ],
  },
  {
    title: "EWRG-Energy",
    src: [
      "data/posters/EWRG-Energy/14.jpg",
      "data/posters/EWRG-Energy/15.jpg",

      "data/posters/EWRG-Energy/16.jpg",
    ],
  },
  {
    title: "EWRG-Aghanashini Estuary",
    src: [
      "data/posters/EWRG-Aghanashini_Estuary/17.jpg",
      "data/posters/EWRG-Aghanashini_Estuary/18.jpg",

      "data/posters/EWRG-Aghanashini_Estuary/19.jpg",

      "data/posters/EWRG-Aghanashini_Estuary/20.jpg",

      "data/posters/EWRG-Aghanashini_Estuary/21.jpg",

    
    ],
  },
  {
    title: "EWRG-Ecosystem Service",
    src: [
      "data/posters/EWRG-Ecosystem_Service/22.jpg",
      "data/posters/EWRG-Ecosystem_Service/23.jpg",

      "data/posters/EWRG-Ecosystem_Service/24.jpg",

      "data/posters/EWRG-Ecosystem_Service/25.jpg",

      "data/posters/EWRG-Ecosystem_Service/26.jpg",

      "data/posters/EWRG-Ecosystem_Service/27.jpg",

      "data/posters/EWRG-Ecosystem_Service/28.jpg",

     

    
    ],
  },
  {
    title: "EWRG-Plants of India",
    src: [
      "data/posters/EWRG-Plants_of_India/29.jpg",
      "data/posters/EWRG-Plants_of_India/30.jpg",

      "data/posters/EWRG-Plants_of_India/31.jpg",

      "data/posters/EWRG-Plants_of_India/32.jpg",

      "data/posters/EWRG-Plants_of_India/33.jpg",

      "data/posters/EWRG-Plants_of_India/34.jpg",

      "data/posters/EWRG-Plants_of_India/35.jpg",

      "data/posters/EWRG-Plants_of_India/36.jpg",

      "data/posters/EWRG-Plants_of_India/37.jpg",

      "data/posters/EWRG-Plants_of_India/38.jpg",

      "data/posters/EWRG-Plants_of_India/39.jpg",

      "data/posters/EWRG-Plants_of_India/40.jpg",

      "data/posters/EWRG-Plants_of_India/41.jpg",

      "data/posters/EWRG-Plants_of_India/42.jpg",
      "data/posters/EWRG-Plants_of_India/43.jpg",

    ],
  },
  {
    title: "Lake 2024 - Presentations",
    src: [
      "data/posters/Lake_2024-Poster_Presentations/44.jpg",
      "data/posters/Lake_2024-Poster_Presentations/45.jpg",

      "data/posters/Lake_2024-Poster_Presentations/46.jpg",

      "data/posters/Lake_2024-Poster_Presentations/47.jpg",

      "data/posters/Lake_2024-Poster_Presentations/48.jpg",

      "data/posters/Lake_2024-Poster_Presentations/49.jpg",

      "data/posters/Lake_2024-Poster_Presentations/50.jpg",

      "data/posters/Lake_2024-Poster_Presentations/51.jpg",

      "data/posters/Lake_2024-Poster_Presentations/52.jpg",

      "data/posters/Lake_2024-Poster_Presentations/53.jpg",

      "data/posters/Lake_2024-Poster_Presentations/54.jpg",

      "data/posters/Lake_2024-Poster_Presentations/55.jpg",

      "data/posters/Lake_2024-Poster_Presentations/56.jpg",

      "data/posters/Lake_2024-Poster_Presentations/57.jpg",

      "data/posters/Lake_2024-Poster_Presentations/58.jpg",

      "data/posters/Lake_2024-Poster_Presentations/59.jpg",
    ],
  },
  {
    title: "Lake 2024 - Thank you",
    src: [
      "data/posters/Lake_2024-Thank_you/62.jpg",],},
];

function PosterPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (src) => {
    setSelectedImage(src);
  };

  return (
    <>
      <ContentOverlay
        text_content={
          <div className="container text-center">
            <h2>Posters</h2>
            <div className="row justify-content-center mt-4">
              {posters.map((poster, index) => (
                <div key={index} className="col-md-5 col-lg-4 m-2">
                  <button
                    className="btn btn-poster w-100"
                    onClick={() => handleImageClick(poster.src)}
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#F8F4E1",
                      mixBlendMode: "multiply",
                      whiteSpace: "normal",
                    }}
                  >
                    {poster.title}
                  </button>
                </div>
              ))}
            </div>
          </div>
        }
      />
      {selectedImage && (
        <CustomModal
          show={true}
          onClose={() => setSelectedImage(null)}
          content={selectedImage} // If it’s an array, pass multiple images
        />
      )}
    </>
  );
}

export default PosterPage;